module.exports = __webpack_public_path__ + "img/apple-iphone-11-pro.385d0c20.jpg";